import * as yup from 'yup';
import numeral from 'numeral';
import {
  FORM_KEYS, NO_OF_CHARS, CLIENT_CLASSIFICATION, TYPE_OF_INVESTMENT,
  QUALIFIED_TYPE_OF_INVESTMENT, GLOBAL, OCCUPATIONS
} from 'shared/constant';
import isValidDay from './date.validation';


const { CLIENT_DETAILS } = FORM_KEYS;

export const clientDetailSchema = (intl, elementName, occupation) => {
  switch (elementName) {
    case CLIENT_DETAILS.CLIENT_CLASSIFICATION:
      return yup.object().shape({
        [CLIENT_DETAILS.CLIENT_CLASSIFICATION]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.classification' }) })),
        //   .max(25, intl.formatMessage({ id: 'validation.invalidMaxNumberOfChars' })),
      });
    case CLIENT_DETAILS.QUALIFIED_INVESTOR:
      return yup.object().shape({
        [CLIENT_DETAILS.QUALIFIED_INVESTOR]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.invalidQualified' })),
      });
    // case CLIENT_DETAILS.INVESTED_AMOUNT:
    //   return yup.object().shape({
    //     [CLIENT_DETAILS.INVESTED_AMOUNT]: yup
    //       .string()
    //       .nullable()
    //       .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
    //   });
    case CLIENT_DETAILS.NATIONALITY:
      return yup.object().shape({
        [CLIENT_DETAILS.NATIONALITY]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.nationality' }) })),
      });
    case CLIENT_DETAILS.DATE_OF_BIRTH:
      return yup.object().shape({
        [CLIENT_DETAILS.DATE_OF_BIRTH]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.dob' }) }))
          .test(
            intl.formatMessage({ id: 'validation.invalidDateFormat' }),
            intl.formatMessage({ id: 'validation.invalidDateFormat' }),
            (value) => {
              if (isValidDay(value)) return true;
              return false;
            },
          ),
        //   ADD MORE DATE FORMAT RULES
      });
    // case CLIENT_DETAILS.CITY_OF_BIRTH:
    //   return yup.object().shape({
    //     [CLIENT_DETAILS.CITY_OF_BIRTH]: yup
    //       .string()
    //       .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.townOrCob' }) })),
    //   });
    case CLIENT_DETAILS.COUNTRY_OF_BIRTH:
      return yup.object().shape({
        [CLIENT_DETAILS.COUNTRY_OF_BIRTH]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.cob' }) })),
      });
    case CLIENT_DETAILS.OCCUPATION:
      return yup.object().shape({
        [CLIENT_DETAILS.OCCUPATION]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.occupationPrincipalActivity' }) })),
      });
    case CLIENT_DETAILS.HOME_ADDRESS:
      return yup.object().shape({
        [CLIENT_DETAILS.HOME_ADDRESS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.homeAddress' }) }))
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    case CLIENT_DETAILS.COUNTRY_OF_RESIDENCE:
      return yup.object().shape({
        [CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.countryOfResidence' }) })),
      });
    case CLIENT_DETAILS.EMAIL_ADDRESS:
      return yup.object().shape({
        [CLIENT_DETAILS.EMAIL_ADDRESS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.emailAddress' }) }))
          .email(intl.formatMessage({ id: 'validation.invalidEmailFormat' })),
      });
    case CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME:
      return yup.object().shape({
        [CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
              if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
              return false;
            },
          ),
        // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.employer' }) }))
        // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
        // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case CLIENT_DETAILS.POSITION:
      return yup.object().shape({
        [CLIENT_DETAILS.POSITION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
              if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
              return false;
            },
          ),
        // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.position' }) })),
      });
    case CLIENT_DETAILS.OFFICE_ADDRESS:
      return yup.object().shape({
        [CLIENT_DETAILS.OFFICE_ADDRESS]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
              if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
              return false;
            },
          ),
        // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.officeAddress' }) }))
        // .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
        // .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

export const qualifiedInvestorSchema = (intl, clientClassification) => yup.object().shape({
  [CLIENT_DETAILS.QUALIFIED_INVESTOR]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED) return false;
        return true;
      },
    ),
});

export const typeOfInvestmentSchema = (intl, clientClassification, product, investmentStrategies, assetAllocation) => yup.object().shape({
  [CLIENT_DETAILS.TYPE_OF_INVESTMENT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (clientClassification === CLIENT_CLASSIFICATION.RETAIL || clientClassification === CLIENT_CLASSIFICATION.QUALIFIED)) return false;
        if (value && (value === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || value === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && !product) return false;
        if (value && value === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY && (investmentStrategies && !investmentStrategies.length)) return false;
        if (value && value === QUALIFIED_TYPE_OF_INVESTMENT.NON_DISCRETIONARY && (!assetAllocation || assetAllocation === '')) return false;
        return true;
      },
    ),
});

export const investedAmountSchema = (intl, typeOfInvestment, productMinInvestAmountData) => yup.object().shape({
  [CLIENT_DETAILS.INVESTED_AMOUNT]: yup
    .string()
    // .nullable()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS)) return false;
        return true;
      },
    )
    .test(
      // eslint-disable-next-line radix
      intl.formatMessage(
        { id: 'validation.minInvestedAmount' },
        { value: numeral(productMinInvestAmountData?.minimumInitialAmount).format('0,0'), currency: productMinInvestAmountData?.currencyLabel || '' },
      ),
      // eslint-disable-next-line radix
      intl.formatMessage(
        { id: 'validation.minInvestedAmount' },
        { value: numeral(productMinInvestAmountData?.minimumInitialAmount).format('0,0'), currency: productMinInvestAmountData?.currencyLabel || '' },
      ),
      (value) => {
        const investedAmt = numeral(value).format('0,0');
        const convertedStr = investedAmt.replace(',', '');
        const min = productMinInvestAmountData?.minimumInitialAmount;
        if ((typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && value && Number(convertedStr) < min) return false;
        return true;
      },
    )
    .test(
      intl.formatMessage({ id: 'validation.maxInvestedAmount' }, { value: numeral(GLOBAL.MAX_INVESTED_AMOUNT).format('0,0') }),
      intl.formatMessage({ id: 'validation.maxInvestedAmount' }, { value: numeral(GLOBAL.MAX_INVESTED_AMOUNT).format('0,0') }),
      (value) => {
        const investedAmt = numeral(value).format('0,0');
        const convertedStr = investedAmt.replace(/,/g, '');
        if ((typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && value && Number(convertedStr) > GLOBAL.MAX_INVESTED_AMOUNT) return false;
        return true;
      },
    ),
});

export const clientDetailPageSchema = (intl, clientClassification, typeOfInvestment, product, investmentStrategies, assetAllocation, productMinInvestAmountData, occupation) => yup.object().shape({
  [CLIENT_DETAILS.CLIENT_CLASSIFICATION]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.classification' }) })),
  [CLIENT_DETAILS.QUALIFIED_INVESTOR]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED) return false;
        return true;
      },
    ),
  [CLIENT_DETAILS.TYPE_OF_INVESTMENT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (clientClassification === CLIENT_CLASSIFICATION.RETAIL || clientClassification === CLIENT_CLASSIFICATION.QUALIFIED)) return false;
        if (value && (value === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || value === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && !product) return false;
        if (value && value === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY && (investmentStrategies && !investmentStrategies.length)) return false;
        if (value && value === QUALIFIED_TYPE_OF_INVESTMENT.NON_DISCRETIONARY && (!assetAllocation || assetAllocation === '')) return false;
        return true;
      },
    ),
  [CLIENT_DETAILS.PRODUCT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS)) return false;
        return true;
      },
    ),
  [CLIENT_DETAILS.INVESTED_AMOUNT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS)) return false;
        return true;
      },
    )
    .test(
      intl.formatMessage(
        { id: 'validation.minInvestedAmount' },
        { value: numeral(productMinInvestAmountData?.minimumInitialAmount).format('0,0'), currency: productMinInvestAmountData?.currencyLabel || '' },
      ),
      intl.formatMessage(
        { id: 'validation.minInvestedAmount' },
        { value: numeral(productMinInvestAmountData?.minimumInitialAmount).format('0,0'), currency: productMinInvestAmountData?.currencyLabel || '' },
      ),
      (value) => {
        const investedAmt = numeral(value).format('0,0');
        const convertedStr = investedAmt.replace(',', '');
        const min = productMinInvestAmountData?.minimumInitialAmount;
        if ((typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && value && Number(convertedStr) < min) return false;
        return true;
      },
    )
    .test(
      intl.formatMessage({ id: 'validation.maxInvestedAmount' }, { value: numeral(GLOBAL.MAX_INVESTED_AMOUNT).format('0,0') }),
      intl.formatMessage({ id: 'validation.maxInvestedAmount' }, { value: numeral(GLOBAL.MAX_INVESTED_AMOUNT).format('0,0') }),
      (value) => {
        const investedAmt = numeral(value).format('0,0');
        const convertedStr = investedAmt.replace(/,/g, '');
        if ((typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS || typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS) && value && Number(convertedStr) > GLOBAL.MAX_INVESTED_AMOUNT) return false;
        return true;
      },
    ),
  [CLIENT_DETAILS.NATIONALITY]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.nationality' }) })),
  [CLIENT_DETAILS.DATE_OF_BIRTH]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.dob' }) })),
  // [CLIENT_DETAILS.CITY_OF_BIRTH]: yup
  //   .string()
  //   .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.townOrCob' }) })),
  [CLIENT_DETAILS.COUNTRY_OF_BIRTH]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.cob' }) })),
  [CLIENT_DETAILS.OCCUPATION]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.occupationPrincipalActivity' }) })),
  [CLIENT_DETAILS.HOME_ADDRESS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.homeAddress' }) })),
  [CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.countryOfResidence' }) })),
  [CLIENT_DETAILS.EMAIL_ADDRESS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.emailAddress' }) })),
  [CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
        if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
        return false;
      },
    ),
  // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.employer' }) })),
  [CLIENT_DETAILS.POSITION]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
        if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
        return false;
      },
    ),
  // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.position' }) })),
  // [CLIENT_DETAILS.OFFICE_ADDRESS]: yup
  //   .string()
  //   .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientDetails.officeAddress' }) })),
  [CLIENT_DETAILS.OFFICE_ADDRESS]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (occupation === OCCUPATIONS.MINOR || occupation === OCCUPATIONS.HOUSE_WIFE)) return true;
        if (value && occupation !== OCCUPATIONS.MINOR && occupation !== OCCUPATIONS.HOUSE_WIFE) return true;
        return false;
      },
    ),
});

// export default clientDetailSchema;
